import React, { FC } from 'react';
import { NightThemeToggle } from './components/NightThemeToggle';
import styles from './WorkstationSettingsPage.module.scss';
import { useTranslation } from 'react-i18next';
export const WorkstationSettingsPage: FC = React.memo(
  function WorkstationSettingsPage() {
    const i18n = useTranslation();
    return (
      <div
        className={styles.page}
        data-test-id="workstations-settings-container"
      >
        <div className={styles.header}>
          <span className={styles.title}>
            {i18n.t('tabs.workstation_settings.title')}
          </span>
        </div>
        <div className={styles.container}>
          <div className={styles.containerTitle}>
            {i18n.t('workstation_settings.themes.title')}
          </div>
          <div className={styles.field}>
            <NightThemeToggle />
            <span className={styles.text}>
              {i18n.t('workstation_settings.themes.night_theme')}
            </span>
          </div>
        </div>
      </div>
    );
  },
);
